<script setup lang="ts">
import BaseNotificationPanel from '@/components/base/BaseNotificationPanel.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const emit = defineEmits<{
  /** Emitted when notification is closed */
  close: []
}>()

defineOptions({ name: 'DemoModeInformer' })

const { t } = useI18n()
const route = useRoute()

const isOnDashboard = computed(() => route.name === 'dashboard')
const to = computed(() => (!isOnDashboard.value ? { name: 'dashboard' } : {}))

const scrollToSteps = (): void => {
  emit('close')

  setTimeout(() => {
    const steps = document.querySelector('#registration-steps')
    steps?.scrollIntoView({ behavior: 'smooth' })
  }, 200)
}
</script>

<template>
  <BaseNotificationPanel status="warning" class="mb-4">
    <slot>
      {{ t('registration_flow.notification.info_generic') }}
    </slot>
    <RouterLink
      class="mt-1 inline-flex items-center justify-start fill-current font-medium text-primary hover:underline"
      :to
      @click.prevent="scrollToSteps"
    >
      <slot name="link">
        {{ t('registration_flow.notification.action_generic') }}
      </slot>
      <VIcon icon="$arrow-right" class="text-primary" />
    </RouterLink>
  </BaseNotificationPanel>
</template>
